import { render, staticRenderFns } from "./SurveyPage1.vue?vue&type=template&id=1438d42a&scoped=true&"
import script from "./SurveyPage1.vue?vue&type=script&lang=js&"
export * from "./SurveyPage1.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPage1.vue?vue&type=style&index=0&id=1438d42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438d42a",
  null
  
)

export default component.exports